export const NUMBER_OF_SECONDS_IN_DAY = 86400;

export const NUMBER_OF_SECONDS_IN_HOUR = 3600;

export const NUMBER_OF_SECONDS_IN_MINUTE = 60;

export const NUMBER_OF_SECONDS_IN_TEN_HOURS = 36000;

export const NUMBER_OF_SECONDS_IN_THIRTY_DAYS = 2592000;
